/* --------------------------------------------------------------------------------------
   usersTable.component.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const usersTableComponent  = {
    template: require('./usersTable.html'),
    controller: 'usersTableCtrl',
    controllerAs: 'vm',
    bindings: {
      users: '<',
      login: '&'
    }
}

export class usersTableCtrl {
  /*@ngInject*/
  constructor(appService, commonService, $state, userService, $scope) {
    this.appService = appService
    this.commonService = commonService
    this.deletealert = false;
    this.userService = userService
    this.$scope = $scope
    this.$state = $state
  }
  $onInit () {
    setTimeout(() => {
      $('#users-tbl').xrxtable({
        theme:'navy',
        height: this.commonService.getScreenHeight() > 481 ? 419 : 310,
        width: this.commonService.getScreenWidth() > 801 ? '942':'760',
        scroll: true,
        bordered: true
      })
    })
  }
  select(user) {
    delete user['hover']
    this.appService.setSelectedUserFromLoginList(user)
    this.login()
  }

  deleteUser(user) {
    this.deletealert = true;
    this.selectedForDeletion = user
  }
  deleteConfirmed() {
    this.deletealert = false;
    this.userService.deleteUser(this.selectedForDeletion)
    this.$state.reload();
  }
  deleteCancel() {
    this.deletealert = false
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/components/usersTable.component.js